/**
 * SpacerSection — vertical whitespace with an optional horizontal rule.
 *
 * Props:
 *   size    'small'|'medium'|'large'   default 'medium'
 *   divider boolean                    default false — show a <hr>-like divider
 *
 * Always renders (it is a layout primitive, not content).
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Box, Divider } from '@mui/material';

const SIZE_MAP = {
  small: { xs: 3, md: 4 },
  medium: { xs: 5, md: 8 },
  large: { xs: 8, md: 14 },
};

export default function SpacerSection({ size, divider }) {
  const py = SIZE_MAP[size] || SIZE_MAP.medium;

  return (
    <Box
      component="div"
      aria-hidden="true"
      sx={{
        py,
        px: divider ? { xs: 3, md: 8 } : 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {divider && (
        <Divider
          sx={{
            width: '100%',
            maxWidth: 'lg',
            opacity: 0.35,
          }}
        />
      )}
    </Box>
  );
}

SpacerSection.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  divider: PropTypes.bool,
};

SpacerSection.defaultProps = {
  size: 'medium',
  divider: false,
};
